import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { theme } from "loft-taxi-mui-theme";
import { configureStore } from './redux/configureStore'
import { MuiThemeProvider } from "@material-ui/core/styles";
import "./index.css";

const store = configureStore();

ReactDOM.render(
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </MuiThemeProvider>
  </MuiPickersUtilsProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
